export default __webpack_public_path__ + "static/media/_Api_algo.245f1652.md";